import { render, staticRenderFns } from "./UpdateDocument.vue?vue&type=template&id=90b070a4&"
import script from "./UpdateDocument.vue?vue&type=script&lang=js&"
export * from "./UpdateDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports